import { useState, useEffect } from "react";

function Galeria() {
    const proyectos = [
        { title: "Proyecto Fénix Power Perú", img: "img/gallery/1.png", desc: "Interpretación consecutiva para entrenamiento de seguridad" },
        { title: "Proyecto CVPUE – Arequipa", img: "img/gallery/2.png", desc: "Interpretación en campo" },
        { title: "Proyecto Fénix Power Perú", img: "img/gallery/3.png", desc: "Interpretación para inspección interna de HRSG" },
        { title: "Proyecto CVPUE - Arequipa", img: "img/gallery/4.png", desc: "Interpretación para cierre de punch list" },
        { title: "Proyecto CVPUE Arequipa", img: "img/gallery/5.png", desc: "Interpretación en campo" },
        { title: "Proyecto CVPUE – Arequipa", img: "img/gallery/6.png", desc: "Interpretación en campo" },
        { title: "Proyecto Fénix Power Perú", img: "img/gallery/8.png", desc: "Interpretación para inspección de seguridad " },
        { title: "Proyecto Fénix Power Perú ", img: "img/gallery/9.png", desc: "Interpretación para inspección de seguridad " },
        { title: "Proyecto Fénix Power Perú", img: "img/gallery/10.png", desc: "Interpretación para instalación de chimenea" },
        { title: "Proyecto Fénix Power Perú ", img: "img/gallery/12.png", desc: "Interpretación para izaje inicial" },
        { title: "Proyecto Fénix Power Perú ", img: "img/gallery/13.png", desc: "Interpretación para simulacro de rescate " },
        { title: "Proyecto Fénix Power Perú ", img: "img/gallery/15.png", desc: "Interpretación para instalación de tablaestacas " },
        { title: "Proyecto CVPUE - Arequipa", img: "img/gallery/16.png", desc: "Interpretación para cierre de punch list" },
        { title: "Ministerio de Cultura ", img: "img/gallery/19.png", desc: "Interpretación de enlace " },
        { title: "Proyecto Las Bambas ", img: "img/gallery/20.png", desc: "On-site translator  " },
        { title: "APEC", img: "img/gallery/21.png", desc: "Interpretación de enlace" },
        { title: "PERUMIN", img: "img/gallery/22.png", desc: "Interpretación de acompañamiento" },
    ];

    const [visible, setVisible] = useState(12);
    const [modalOpen, setModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    const abrirModal = (index) => {
        setCurrentIndex(index);
        setModalOpen(true);
    };

    const siguiente = () => {
        setCurrentIndex((prev) => (prev + 1) % proyectos.length);
    };

    const anterior = () => {
        setCurrentIndex((prev) => (prev - 1 + proyectos.length) % proyectos.length);
    };

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (!modalOpen) return;

            if (e.key === "ArrowRight") siguiente();
            if (e.key === "ArrowLeft") anterior();
            if (e.key === "Escape") setModalOpen(false);
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => window.removeEventListener("keydown", handleKeyDown);
    }, [modalOpen]);

    return (
        <>
            <section className="proyectos" id="proyectos">
                <div className="wrap">

                    <div className="sec-title">
                        <h2>Galería</h2>
                        <div className="bar"></div>
                    </div>

                    <div className="proy-grid">
                        {proyectos.slice(0, visible).map((item, index) => (
                            <div
                                key={index}
                                className="proy-card"
                                onClick={() => abrirModal(index)}
                            >
                                <img src={item.img} alt={item.title} />
                            </div>
                        ))}
                    </div>

                    {visible < proyectos.length && (
                        <div style={{ textAlign: "center", marginTop: 15 }}>
                            <button
                                className="btn-ver-mas btn btn-gold"
                                onClick={() => setVisible(proyectos.length)}
                            >
                                Ver más
                            </button>
                        </div>
                    )}

                </div>
            </section>

            {modalOpen && (
                <div
                    className="modal"
                    onClick={() => setModalOpen(false)}
                >
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <span
                            className="close"
                            onClick={() => setModalOpen(false)}
                        >
                            &times;
                        </span>

                        <button className="prev" onClick={anterior}>
                            &#10094;
                        </button>

                        <img
                            src={proyectos[currentIndex].img}
                            alt={proyectos[currentIndex].title}
                        />

                        <button className="next" onClick={siguiente}>
                            &#10095;
                        </button>

                        <h3 style={{ color: "#02183E" }}>
                            {proyectos[currentIndex].title}
                        </h3>

                        <p style={{ color: "#02183E" }}>
                            {proyectos[currentIndex].desc}
                        </p>
                    </div>
                </div>
            )}
        </>
    );
}

export default Galeria;